
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {api, handleError} from '../../shared/api-loaders';
import {Observable} from 'rxjs';
import {SecurityQuestion} from '../model/security-question';
import {SqResetPassword} from '../../reset-password/model/sq-reset-password';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SecurityQuestionResponse } from '../model/security-question-response';
import { ChangePasswordRequest } from '../model/change-password-request';

@Injectable()
export class MyProfileService {

  constructor(private _http: HttpClient) {
  }

  myProfile_ChangePassword(id: string, body: ChangePasswordRequest) {
    return this._http
      .post(api.changePassword(id), body).pipe(
      catchError(handleError));
  }

  myProfile_SecurityQuestions(params: HttpParams): Observable<SecurityQuestionResponse> {
    return this._http
      .get(api.securityQuestions(), { params: params }).pipe(
        catchError(handleError));
  }

  myProfile_SaveUserSecurityQuestions( userSecurityQuestion: SecurityQuestion[]) {
    return this._http
      .post(api.saveUserSQ(), userSecurityQuestion).pipe(
      catchError(handleError));
  }

  myProfile_userSecurityQuestions(): Observable<SecurityQuestion[]> {
    return this._http
      .get(api.getUserSQ()).pipe(
      catchError(handleError),);
  }

  myProfile_sqResetPassword(sqResetPassword: SqResetPassword) {
    return this._http
      .post(api.sqResetPassword(), sqResetPassword).pipe(
      catchError(handleError));
  }

}
